import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Models API calls
 */
const vehicleModelService = {
  /**
   * Get all vehicle models with pagination and filters
   */
  getAllModels: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        make = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        make,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_MODELS.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.getAllModels'));
    }
  },

  /**
   * Get a single vehicle model by ID
   */
  getModelById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_MODELS.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.getModelById'));
    }
  },

  /**
   * Create a new vehicle model
   */
  createModel: async (modelData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_MODELS.CREATE, modelData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.createModel'));
    }
  },

  /**
   * Update a vehicle model
   */
  updateModel: async (id, modelData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_MODELS.UPDATE(id), modelData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.updateModel'));
    }
  },

  /**
   * Delete a vehicle model
   */
  deleteModel: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_MODELS.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.deleteModel'));
    }
  },

  /**
   * Delete multiple vehicle models
   */
  deleteMultipleModels: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_MODELS.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.deleteMultipleModels'));
    }
  },

  /**
   * Toggle model status
   */
  toggleModelStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_MODELS.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleModelService.toggleModelStatus'));
    }
  },
};

export default vehicleModelService;

